var exports = {
  "Qs": "GuildOwnershipWarningModal.module__content___TXVrUU",
  "OW": "GuildOwnershipWarningModal.module__guildList___TXVrUU",
  "RZ": "GuildOwnershipWarningModal.module__guildItem___TXVrUU",
  "$f": "GuildOwnershipWarningModal.module__guildIcon___TXVrUU",
  "OA": "GuildOwnershipWarningModal.module__guildInfo___TXVrUU",
  "J5": "GuildOwnershipWarningModal.module__guildName___TXVrUU",
  "i1": "GuildOwnershipWarningModal.module__remainingCount___TXVrUU",
  "BK": "GuildOwnershipWarningModal.module__helpText___TXVrUU",
};

module.exports = exports;
